<template>
  <v-container class="not-found-wrapper">
    <lottie-animation
      class="ma-0 boat"
      height="300%"
      path="../404.json"
      :loop="true"
      :autoPlay="true"
      :speed="0.3"
    />
    <h1>Error 404</h1>
    <h6>{{ $t("404") }}</h6>
  </v-container>
</template>
<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs

export default {
  name: "404",
  //{v-container}
  components: {
    LottieAnimation
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/global";
.not-found-wrapper {
  min-height: 30vh;
  display: flex;
  // top: -40px !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.boat {
  width: 80% !important;
}
h1 {
  margin-top: -90px;
  text-decoration: underline;
  color: $dark-blue !important;
}
@media (max-width: 960px) {
  .not-found-wrapper {
    min-height: 85vh;
  }
  // .boat {
  //   width: 70% !important;
  // }
  h1 {
    margin-top: -20px;
  }
}
@media (max-width: 768px) {
  .boat {
    width: 100% !important;
  }
}
</style>
